import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: localStorage.getItem("token"),
  details: JSON.parse(localStorage.getItem("userDetails")) || {
    name: "",
    compName: "",
    email: "",
    customerCode: "",
    phoneNumber: "",
    stateName: "",
    city: "",
    pinCode: "",
    isApproved: false,
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      state.token = action.payload.token;
    },
    userDetails(state, action) {
      state.details = action.payload.details;
    },
    logout(state) {
      state.token = null;
      localStorage.removeItem("token");
      localStorage.removeItem('userDetails')
    },
  },
});

export const authAction = authSlice.actions;

export default authSlice.reducer;